import { render, staticRenderFns } from "./BankAccountBalanceCard.vue?vue&type=template&id=2fabcb60&"
import script from "./BankAccountBalanceCard.vue?vue&type=script&lang=js&"
export * from "./BankAccountBalanceCard.vue?vue&type=script&lang=js&"
import style0 from "./BankAccountBalanceCard.vue?vue&type=style&index=0&id=2fabcb60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports